var map = {
	"./en/menu-1-active.png": "gL0X",
	"./en/menu-2-active.png": "GhOH",
	"./en/menu-3-active.png": "FutC",
	"./en/menu-4-active.png": "YhEF",
	"./en/menu-5-active.png": "DEZO",
	"./menu-1-active.png": "5SaZ",
	"./menu-2-active.png": "xVIa",
	"./menu-3-active.png": "Iq3B",
	"./menu-4-active.png": "ZO6g",
	"./menu-5-active.png": "YKrS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oqgs";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4 ^\.\/.*\-active\.png$
// module id = oqgs
// module chunks = 0